import * as React from "react";
import { Alert } from "@grandvisionhq/iris-ui";
import { useIntl } from "@grandvisionhq/state";
import { useStoreFinderContext } from "../../../../context/StoreFinder/context/StoreFinder/context.js";
const StoreFinderFilterWarning = ({
  hasActiveFilters,
  applyActiveFilters
}) => {
  const { getLabel } = useIntl();
  const { stores } = useStoreFinderContext();
  const filteredStores = React.useMemo(
    () => applyActiveFilters(stores),
    [stores, applyActiveFilters]
  );
  if (stores.length === 0) {
    return null;
  }
  if (!hasActiveFilters) {
    return null;
  }
  if (filteredStores.length !== 0) {
    return null;
  }
  return /* @__PURE__ */ React.createElement(Alert, { variant: "warning", className: "alert-m-default" }, /* @__PURE__ */ React.createElement("div", null, getLabel("stores.page.search.filters.warning")));
};
export {
  StoreFinderFilterWarning,
  StoreFinderFilterWarning as default
};
//# sourceMappingURL=StoreFinderFilterWarning.js.map
